import { useState } from "react";
import RandomQuote from "../../components/RandomQuote/RandomQuote";
import BrandTitle from "../../components/BrandTitle/BrandTitle";
import { useTranslation } from "react-i18next";

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");

    const res = await fetch(
      `${import.meta.env.VITE_API_URL}/api/auth/forgot-password`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      }
    );

    const data = await res.json();
    setStatus(data.message);
  };

  return (
    <div className="authentication-view">
      <div className="left-wrapper">
        <div className="title">
          <BrandTitle fontSize={40} className="brand-title-login" />
        </div>
        <div className="quote">
          <RandomQuote />
        </div>
      </div>
      <div className="right-wrapper">
        <div className="title">{t("auth.forgotPassword.title")}</div>
        <form onSubmit={handleSubmit}>
          <input
            className="flow-form"
            type="email"
            placeholder={t("common.email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <br />
          <button type="submit" className="flow-button">
            {t("auth.forgotPassword.submit")}
          </button>
        </form>
        {status && (
          <span style={{ marginTop: "10px", marginBottom: "-10px" }}>
            {status}
          </span>
        )}
        <p>
          <a className="link" href="/login">
            &larr; {t("auth.backToLogin")}
          </a>
        </p>
      </div>
    </div>
  );
}
